import { render } from "./contract_data.vue?vue&type=template&id=88f927de&scoped=true"
import script from "./contract_data.vue?vue&type=script&lang=js"
export * from "./contract_data.vue?vue&type=script&lang=js"

import "./contract_data.vue?vue&type=style&index=0&id=88f927de&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88f927de"]])

export default __exports__